module.exports = __webpack_public_path__ + "static/media/05_blanco.39830c60.svg";